var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowsAngleExpand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.596645 7.25195C0.811955 7.25195 0.986502 7.4265 0.986502 7.64181V10.3708H3.7155C3.93081 10.3708 4.10536 10.5454 4.10536 10.7607C4.10536 10.976 3.93081 11.1505 3.7155 11.1505H0.596645C0.381335 11.1505 0.206787 10.976 0.206787 10.7607V7.64181C0.206787 7.4265 0.381335 7.25195 0.596645 7.25195Z",
    fill: "#A0A3A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.38114 6.94827C4.45447 7.02141 4.49567 7.12072 4.49567 7.22429C4.49567 7.32786 4.45446 7.42717 4.38114 7.50031L0.872423 11.009C0.719986 11.1615 0.472823 11.1615 0.320386 11.009C0.167941 10.8566 0.167948 10.6094 0.320386 10.457L3.8291 6.94827C3.90224 6.87495 4.00156 6.83374 4.10513 6.83374C4.20869 6.83374 4.308 6.87495 4.38115 6.94827H4.38114ZM11.0088 0.32058C11.0822 0.39372 11.1234 0.493035 11.1234 0.596602C11.1234 0.70017 11.0822 0.799477 11.0088 0.872625L7.50011 4.38134C7.34767 4.53379 7.10051 4.53379 6.94807 4.38134C6.79563 4.2289 6.79563 3.98174 6.94807 3.8293L10.4568 0.320587C10.5299 0.24726 10.6292 0.206055 10.7328 0.206055C10.8364 0.206055 10.9357 0.247267 11.0088 0.320587V0.32058Z",
    fill: "#A0A3A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25195 0.596645C7.25195 0.381335 7.4265 0.206787 7.64181 0.206787H10.7607C10.976 0.206787 11.1505 0.381335 11.1505 0.596645V3.7155C11.1505 3.93081 10.976 4.10536 10.7607 4.10536C10.5454 4.10536 10.3708 3.93081 10.3708 3.7155V0.986502H7.64181C7.4265 0.986502 7.25195 0.811955 7.25195 0.596645Z",
    fill: "#A0A3A3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsAngleExpand);
export default __webpack_public_path__ + "static/media/arrows-angle-expand.dfb1902b.svg";
export { ForwardRef as ReactComponent };